<template>
  <div class="tab-content-presentation">
    <RightColumnCommonSlidesConfig v-if="isUsingComponentCommonSlidesConfig" />

    <RightColumnImageConfig v-if="isUsingComponentImageConfig" />
    <div v-if="slideActive.slideType === 'categorise'">
      <CategoriseConfig />
    </div>

    <div v-if="slideActive.type === 'youtube'">
      <YoutubeConfig />
    </div>

    <div v-if="slideActive.type === 'googleSlides'">
      <GoogleSlidesContentTab />
    </div>

    <div v-if="slideActive.type === 'spinnerWheel'">
      <SpinnerWheelContentTab />
    </div>

    <div v-if="slideActive.type === 'freestyle'">
      <FreestyleContentTab />
    </div>

    <div v-if="slideActive.type === 'qrcode'" class="mb-3">
      {{ $i18nPresenter.t('You can put this slide at the beginning of your presentation. You can also put this slide just before an interactive slide, so the audience are reminded again to join in with their devices.') }}
    </div>

    <AhaInfoBox v-if="isReactionInfoBoxShowing">
      {{ $i18nPresenter.t('Reactions are now available on all slides.') }}
    </AhaInfoBox>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

import RightColumnCommonSlidesConfig from '@/components-v2/presentation-editor/side-right/RightColumnCommonSlidesConfig.vue'
import RightColumnImageConfig from '@/components-v2/presentation-editor/side-right/RightColumnImageConfig.vue'
import YoutubeConfig from '@/components/presentations/types/YoutubeConfig.vue'
import CategoriseConfig from '@/components/presentations/types/Categorise/CategoriseConfig.js'
import GoogleSlidesContentTab from '@/components/presentations/types/GoogleSlidesContentTab.vue'
import SpinnerWheelContentTab from '@/components/presentations/types/SpinnerWheelContentTab.vue'
import FreestyleContentTab from '@/components/presentations/types/FreestyleContentTab.vue'

export default {
  components: {
    RightColumnCommonSlidesConfig,
    RightColumnImageConfig,
    YoutubeConfig,
    GoogleSlidesContentTab,
    SpinnerWheelContentTab,
    FreestyleContentTab,
    CategoriseConfig,
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    isUsingComponentCommonSlidesConfig() {
      const { type } = this.slideActive
      const slideSubType = this.slideActive.slideType
      const slideTypes = [
        'multipleChoice',
        'imageChoice',
        'question',
        'openEnded',
        'wordCloud',
        'scale',
        'ideas',
        'pickAnswer',
        'leaderboard',
        'textSlide',
        'bulletPoints',
      ]

      const excludeSubTypes = ['categorise']

      return slideTypes.includes(type) && !excludeSubTypes.includes(slideSubType)
    },
    isUsingComponentImageConfig() {
      const slideTypes = ['image', 'document']
      return slideTypes.includes(this.slideActive.type)
    },
    isReactionInfoBoxShowing() {
      return moment('2021/11/01').isAfter(moment())
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-content-presentation {
  padding: 0;
  position: relative;
  z-index: 7; // https://ahaslides.atlassian.net/browse/AHA-14039
}
</style>
